export const YANDEX_METRIKA_GOALS = {
    registerStart: 'market-register-start',
    registerComplete: 'market-register-complete',
    offerComplete: 'market-offer-complete',
    offerJoin: 'market-offer-join',
} as const

export type YandexMetrikaGoal = typeof YANDEX_METRIKA_GOALS[keyof typeof YANDEX_METRIKA_GOALS]

type Metrika = {
    reachGoal?: (target: string, params?: Record<string, unknown>) => void
}

export function useYandexMetrikaGoals() {
    const reachGoal = (target: YandexMetrikaGoal, params?: Record<string, unknown>) => {
        if (!import.meta.client) return

        const { $metrika } = useNuxtApp() as { $metrika?: Metrika }

        try {
            $metrika?.reachGoal?.(target, params)
        } catch (error) {
            if (import.meta.dev) {
                console.warn('[yandex.metrika] failed to reach goal', target, error)
            }
        }
    }

    return {
        goals: YANDEX_METRIKA_GOALS,
        reachGoal,
    }
}
